<!-- Main Application Layout Container -->
<div
  class="layout-container"
  [class.beta-access-enabled-for-user]="isBetaAccessPrivilegeConsumableForUser"
  [class.beta-access-disabled-for-user]="!isBetaAccessPrivilegeConsumableForUser"
  [class.beta-access-enabled]="isBetaAccessPrivilegeConsumable"
  [class.beta-access-disabled]="!isBetaAccessPrivilegeConsumable"
  [class.chat-panel-collapsed]="isChatCollapsed"
  [class.is-outside-app-main]="isAppManagementPage"
  [class.is-inside-app-main]="!isAppManagementPage"
>
  <!-- Left Panel: Chat/Companion Interface -->
  <aside
    class="chat-panel"
    [class.collapsed]="isChatCollapsed"
    [class.expanded-mode]="isContentCollapsed"
    [style.width.px]="isChatCollapsed ? collapsedChatWidth : chatWidth"
    *ngIf="!isAppManagementPage && isBetaAccessPrivilegeConsumable"
  >
    <!-- Collapsed-rail actions (vertical) shown only when the chat rail is collapsed -->
    <div class="chat-header" *ngIf="isChatCollapsed">
      <div class="header-left-group">
        <button class="icon-btn-small" title="Toggle chat" (click)="toggleChat()">
          <rt-toggle-view-icon [width]="20" [height]="20"></rt-toggle-view-icon>
        </button>
        <button
          class="icon-btn-small"
          [class.active]="isSessionsPanelOpen"
          title="Sessions"
          (click)="onOpenSessionPanel()"
        >
          <rt-inbox-icon [width]="20" [height]="20"></rt-inbox-icon>
        </button>
        <button
          class="icon-btn-small"
          [class.active]="isNewSessionActive"
          title="Create session"
          (click)="onCreateNewSession()"
        >
          <rt-message-icon [width]="20" [height]="20"></rt-message-icon>
        </button>
      </div>
    </div>

    <!-- New Session Header Boilerplate -->
    <div class="active-session-header dummy-session-header" *ngIf="isNewSessionActive && !isChatCollapsed">
      <div class="session-info-card">
        <div class="card-header-row">
          <div class="left-section">
            <span class="icon-wrapper">
              <rt-light-bulb-icon *ngIf="chatboxMode === 'ideate'" width="17" height="17"></rt-light-bulb-icon>

              <rt-icon-message-text-square-01
                *ngIf="chatboxMode !== 'ideate' && chatboxMode !== 'auto'"
                width="17"
                height="17"
                class="d-flex"
              ></rt-icon-message-text-square-01>

              <rt-icon-cube-01 *ngIf="chatboxMode === 'auto'" width="17" height="17" class="d-flex"></rt-icon-cube-01>
            </span>
            <span class="session-name" title="New session">New session</span>
          </div>
          <div class="right-section flex-row-center">
            <!-- Boilerplate template: no ellipsis and chevron -->
          </div>
        </div>
      </div>
    </div>

    <!-- Active Session Header -->
    <div class="active-session-header" *ngIf="activeSession.sid && !isNewSessionActive && !isChatCollapsed">
      <div class="session-info-card">
        <div class="card-header-row">
          <div class="left-section">
            <span class="icon-wrapper">
              <rt-light-bulb-icon
                *ngIf="activeSession.mode === SESSION_MODE.IDEATE"
                width="17"
                height="17"
              ></rt-light-bulb-icon>

              <rt-icon-message-text-square-01
                *ngIf="activeSession.mode === SESSION_MODE.BUILD && activeSession.driven === SESSION_DRIVEN_MODE.MANUAL"
                width="17"
                height="17"
                class="d-flex"
              ></rt-icon-message-text-square-01>

              <rt-icon-cube-01
                *ngIf="activeSession.mode === SESSION_MODE.BUILD && activeSession.driven === SESSION_DRIVEN_MODE.AUTO"
                width="17"
                height="17"
                class="d-flex"
              ></rt-icon-cube-01>
            </span>
            <span class="session-name" [title]="activeSession.sessionName">{{ activeSession.sessionName }}</span>
          </div>

          <div class="right-section flex-row-center">
            <ng-container
              *ngIf="
                activeSession.mode === SESSION_MODE.IDEATE &&
                appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS
              "
            >
              <button
                class="action-btn icon-style view-changes-btn"
                title="'System Blueprint' Merge is currently in progress"
              >
                <i class="fa fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
              </button>
            </ng-container>

            <button
              class="icon-btn action-icon p-button-rounded p-button-text p-button-sm"
              (click)="sessionMenu.toggle($event)"
              title="More Options"
            >
              <i class="pi pi-ellipsis-h"></i>
            </button>
            <p-menu
              #sessionMenu
              [model]="sessionMenuItems"
              [popup]="true"
              appendTo="body"
              styleClass="session-kebab-menu"
            ></p-menu>
            <button
              class="icon-btn action-icon"
              (click)="isSessionSummaryExpanded = !isSessionSummaryExpanded"
              title="Toggle Summary"
              [disabled]="!activeSession?.summary"
              [style.cursor]="!activeSession?.summary ? 'not-allowed' : ''"
              *ngIf="activeSession?.mode === SESSION_MODE.IDEATE"
            >
              <i class="pi" [ngClass]="isSessionSummaryExpanded ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
            </button>
          </div>
        </div>

        <div
          class="session-summary-body"
          *ngIf="isSessionSummaryExpanded && activeSession?.mode === SESSION_MODE.IDEATE"
        >
          <div class="summary-section">
            <p class="summary-text">{{ activeSession.summary }}</p>
          </div>
        </div>

        <!--  FLOATING_TO_DO_CARD for Pending Plan Outline -->
        <div class="pending-todos-bar" *ngIf="pendingTodosStats && pendingPlanOutlineMsg as todoMsg">
          <div
            class="todos-header cursor-pointer"
            [class.collapsed-header]="isTodoCardCollapsed"
            (click)="isTodoCardCollapsed = !isTodoCardCollapsed"
            (keydown.enter)="isTodoCardCollapsed = !isTodoCardCollapsed"
            (keydown.space)="isTodoCardCollapsed = !isTodoCardCollapsed"
            tabindex="0"
            style="user-select: none"
          >
            <div class="todos-title-container" style="display: flex; gap: 8px; flex: 1; pointer-events: none">
              <span class="todos-title" *ngIf="!isTodoCardCollapsed && pendingTodosStats?.length === 1">
                <span>{{ pendingTodosStats[0].title }}</span>
              </span>
              <div class="todos-title collapsed" *ngIf="isTodoCardCollapsed && pendingTodosStats?.length === 1">
                <app-spinner-icon [size]="16" style="margin-right: 4px"></app-spinner-icon>

                <span class="ml-1">{{ pendingTodosStats[0].inProgressItemTitle }}</span>
              </div>
            </div>
            <rt-icon-chevron-right
              style="transition: transform 0.2s"
              [style.transform]="!isTodoCardCollapsed ? 'rotate(270deg)' : 'rotate(90deg)'"
              width="14"
              height="14"
            ></rt-icon-chevron-right>
            <span class="todos-title stats-holder ml-1" *ngIf="pendingTodosStats?.length === 1">
              <span class="stats">{{ pendingTodosStats[0].completed }}/{{ pendingTodosStats[0].total }}</span>
            </span>
          </div>

          <div class="todos-body" *ngIf="!isTodoCardCollapsed">
            <ng-container *ngFor="let section of todoMsg.content?.sections || todoMsg.sections">
              <div class="todo-item" *ngFor="let item of section.items">
                <div class="todo-icon-wrapper">
                  <svg-icon
                    *ngIf="item.status === 'successful'"
                    [src]="'assets/designIconLib/SVG/check-circle.svg'"
                    [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"
                    class="{{ item.status }}"
                  ></svg-icon>
                  <app-spinner-icon
                    *ngIf="item.status === 'in-progress'"
                    [size]="16"
                    class="{{ item.status }}"
                  ></app-spinner-icon>
                  <svg-icon
                    *ngIf="item.status === 'failed'"
                    [src]="'assets/designIconLib/SVG/x-circle.svg'"
                    [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"
                    class="{{ item.status }}"
                  ></svg-icon>
                  <svg-icon
                    *ngIf="item.status === 'pending' || !item.status"
                    [src]="'assets/designIconLib/additions/dash-circle.svg'"
                    [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
                    class="{{ item.status }}"
                  ></svg-icon>
                </div>
                <span class="todo-text status-{{ item.status }}">{{ item.text }}</span>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="card-action-row" *ngIf="activeSession?.sid && activeSession?.mode === SESSION_MODE.IDEATE">
          <div
            class="action-left-section"
            *ngIf="
              appDetail?.mergeStatus !== SESSION_MERGE_STATUS.IN_PROGRESS &&
              activeSession.isOwner &&
              (activeSession?.mergeStatus === SESSION_MERGE_STATUS.YET_TO_START ||
                activeSession?.mergeStatus === SESSION_MERGE_STATUS.FAILED) &&
              !(activeBPSession?.SessionBP_PC?.isEmpty && activeBPSession?.SessionBP_FD?.isEmpty)
            "
          >
            <div class="changeset-pill-group">
              <button
                class="pill-btn"
                [class.active]="changesetViewMode === 'system_only'"
                (click)="setChangesetViewMode('system_only')"
                [disabled]="isSessionConfirmationPending || Flags.isSessionActionsDisabled"
                title="System Blueprint"
              >
                <svg-icon
                  [src]="'assets/designIconLib/SVG/eye-off.svg'"
                  [svgStyle]="{ 'width.px': 15, 'height.px': 15 }"
                ></svg-icon>
                <span class="pill-label" *ngIf="changesetViewMode === 'system_only'">{{ 'HIDE' | translate }}</span>
              </button>
              <button
                class="pill-btn"
                [class.active]="changesetViewMode === 'session_and_system'"
                (click)="setChangesetViewMode('session_and_system')"
                [disabled]="isSessionConfirmationPending || Flags.isSessionActionsDisabled"
                title="Session Blueprint"
              >
                <svg-icon
                  [src]="'assets/designIconLib/SVG/eye.svg'"
                  [svgStyle]="{ 'width.px': 15, 'height.px': 15 }"
                ></svg-icon>
                <span class="pill-label" *ngIf="changesetViewMode === 'session_and_system'">{{
                  'VIEW' | translate
                }}</span>
              </button>
              <button
                class="pill-btn"
                [class.active]="changesetViewMode === 'session_vs_system'"
                (click)="setChangesetViewMode('session_vs_system')"
                [disabled]="isSessionConfirmationPending || Flags.isSessionActionsDisabled"
                title="Session Blueprint - View changes"
              >
                <svg-icon
                  [src]="'assets/designIconLib/SVG/intersect-circle.svg'"
                  [svgStyle]="{ 'width.px': 15, 'height.px': 15 }"
                ></svg-icon>
                <span class="pill-label" *ngIf="changesetViewMode === 'session_vs_system'">{{
                  'COMPARE' | translate
                }}</span>
              </button>
            </div>
          </div>
          <div
            class="action-right-section"
            *ngIf="
              appDetail?.mergeStatus !== SESSION_MERGE_STATUS.IN_PROGRESS &&
              (activeSession?.mergeStatus === SESSION_MERGE_STATUS.YET_TO_START ||
                activeSession?.mergeStatus === SESSION_MERGE_STATUS.FAILED) &&
              !(activeBPSession?.SessionBP_PC?.isEmpty && activeBPSession?.SessionBP_FD?.isEmpty)
            "
          >
            <button
              class="action-btn primary action-btn scenario-done"
              (click)="onApproveSession()"
              *ngIf="activeSession.isOwner"
              [disabled]="isSessionConfirmationPending || Flags.isSessionActionsDisabled"
            >
              <i class="pi pi-check"></i>
              <span>{{ 'DONE' | translate }}</span>
            </button>

            <button class="action-btn primary action-btn scenario-read-only" *ngIf="!activeSession.isOwner">
              <svg-icon
                [src]="'assets/designIconLib/SVG/file-lock-02.svg'"
                [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"
              ></svg-icon>
              <span>{{ 'READ_ONLY' | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="chat-body" #chatScrollContainer (scroll)="onChatScroll($event)">
      <div class="loading-sessions-indicator" *ngIf="isLoadingSessions">
        <div class="brand-spinner-wrapper">
          <app-brand-icon class="spinning-brand" [width]="24" [height]="24"></app-brand-icon>
        </div>
      </div>

      <!-- New Session Banner -->
      <div
        class="chat-welcome h-100 d-flex flex-column align-items-center justify-content-center"
        *ngIf="!isLoadingSessions && isNewSessionActive && messages.length === 0 && !isSessionsPanelOpen"
      >
        <div
          class="text-center w-100 d-flex flex-column align-items-center justify-content-center mt-auto mb-auto"
          style="flex: 1"
        >
          <ng-container *ngIf="chatboxMode !== 'ideate'">
            <svg-icon
              [src]="'assets/designIconLib/SVG/message-chat-square.svg'"
              [svgStyle]="{ 'width.px': 36, 'height.px': 36, color: 'var(--neutral-400)' }"
              class="mb-2 custom-svg-icon"
            ></svg-icon>
            <span
              class="text-secondary font-weight-medium text-center"
              [innerHTML]="'START_NEW_SESSION_TEASER' | translate"
            ></span>
          </ng-container>

          <ng-container *ngIf="chatboxMode === 'ideate'">
            <svg-icon
              [src]="'assets/designIconLib/SVG/lightbulb-02.svg'"
              [svgStyle]="{ 'width.px': 36, 'height.px': 36, color: 'var(--neutral-400)' }"
              class="mb-2 custom-svg-icon"
            ></svg-icon>

            <span
              class="text-secondary font-weight-medium text-center"
              [innerHTML]="'START_NEW_IDEATE_SESSION_TEASER' | translate"
            ></span>
          </ng-container>
        </div>
      </div>

      <div class="chat-messages" *ngIf="messages.length > 0 && !isSessionsPanelOpen">
        <div
          class="message"
          *ngFor="let msg of messages; let i = index; trackBy: trackByMessage"
          [class.user-message]="msg.type === 'user'"
          [class.assistant-message]="msg.type === 'assistant'"
          [class.fetching-message]="msg.isFetching"
          [style.display]="
            msg.type === 'assistant' &&
            msg.displayedText === '' &&
            !msg.isFetching &&
            !msg.plan &&
            !(msg.treeTableData && msg.treeTableData.length > 0) &&
            msg.messageType !== ChatMessageType.SHIMMER
              ? 'none'
              : 'flex'
          "
        >
          <!-- Text Message Wrapper -->
          <div
            class="message-content-wrapper-row"
            *ngIf="
              msg.text &&
              msg.messageType !== ChatMessageType.SHIMMER &&
              msg.messageType !== ChatMessageType.QUESTION_AND_ANSWERS &&
              msg.messageType !== ChatMessageType.RECOMMENDATION
            "
            [class.display-none]="msg.tableCards && msg.tableCards.length > 0"
            style="display: flex; flex-direction: row; align-items: center; width: 100%; gap: 12px"
            [style.justify-content]="msg.type === 'user' ? 'flex-end' : 'flex-start'"
          >
            <div
              class="message-content"
              [class.role-setup-message]="msg.tableCards && msg.tableCards.length > 0"
              style="margin: 0; width: fit-content"
            >
              <div
                class="msg-content-wrapper"
                *ngIf="
                  !msg.isCollapsed &&
                  msg.messageType !== ChatMessageType.PLAN &&
                  msg.messageType !== ChatMessageType.PLAN_OUTLINE
                "
              >
                <div
                  *ngIf="msg.text && msg.messageType !== ChatMessageType.USER_RESPONSE"
                  [style.display]="'block'"
                  [style.align-items]="'initial'"
                >
                  <ng-container *ngIf="msg.renderAsHtml; else plainText">
                    <div class="msg-content" style="flex: 1" [innerHTML]="getDisplayText(msg)"></div>
                  </ng-container>
                  <ng-template #plainText>
                    <div class="msg-content" style="flex: 1">{{ getDisplayText(msg) }}</div>
                  </ng-template>
                </div>

                <div
                  *ngIf="msg.messageType === ChatMessageType.USER_RESPONSE && getActionTakenLabel(msg) as actionLabel"
                >
                  <div class="msg-content" style="flex: 1">{{ actionLabel }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- QA Submission Formatted Block -->
          <div
            class="message-content-wrapper-row qa-submission-row"
            *ngIf="
              msg.messageType === ChatMessageType.QUESTION_AND_ANSWERS && msg.status === ChatMessageStatus.COMPLETED
            "
            [ngClass]="msg.type === 'user' ? 'justify-end' : 'justify-start'"
          >
            <div class="message-content qa-submission-content" [class.collapsed]="msg.isCollapsed">
              <div
                class="qa-submission-header"
                (click)="msg.isCollapsed = !msg.isCollapsed"
                (keydown.enter)="msg.isCollapsed = !msg.isCollapsed"
                (keydown.space)="msg.isCollapsed = !msg.isCollapsed"
                tabindex="0"
              >
                <div class="header-label-wrapper">
                  <svg-icon
                    [src]="'assets/designIconLib/SVG/message-question-square.svg'"
                    [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"
                  ></svg-icon>
                  <span class="user-response-label">{{ 'QUESTIONS_ANSWERED' | translate }}</span>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--neutral-500)"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="collapse-icon"
                  [ngStyle]="{
                    transform: msg.isCollapsed ? 'rotate(0deg)' : 'rotate(-180deg)',
                    transition: 'transform 0.2s ease'
                  }"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
              <div class="qa-items-container" *ngIf="!msg.isCollapsed">
                <div class="qa-item" *ngFor="let item of msg.content">
                  <div class="qa-question" *ngIf="!item.skippedAll">
                    {{ item.questionText }}
                  </div>
                  <div class="qa-answer" [class.no-margin]="item.skippedAll">
                    {{ item.answer }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- SHIMMER TIMELINE  -->
          <div
            class="message-content shimmer-timeline-container"
            *ngIf="
              msg.messageType === ChatMessageType.SHIMMER &&
              !msg.isGrouped &&
              msg.status === ChatMessageStatus.COMPLETED
            "
            [class.completed-shimmer]="msg.status === ChatMessageStatus.COMPLETED"
            (click)="toggleCollapse(msg)"
            (keydown.enter)="toggleCollapse(msg)"
            (keydown.space)="toggleCollapse(msg)"
            tabindex="0"
          >
            <!-- Header Section -->
            <div class="shimmer-tl-header">
              <div class="msg-header-left completed-header" *ngIf="msg.status === ChatMessageStatus.COMPLETED">
                <div class="shimmer-icon-wrapper" [class.is-expanded]="!msg.isCollapsed">
                  <rt-icon-search-md width="12" height="12" class="search-icon default-icon"></rt-icon-search-md>
                  <rt-icon-chevron-right
                    class="hover-icon"
                    [class.turn-down]="!msg.isCollapsed"
                  ></rt-icon-chevron-right>
                </div>
                <div class="header-text-container">
                  <span class="header-text">
                    {{ msg.latestShimmerTitle }}
                  </span>
                </div>
              </div>

              <div class="msg-header-left completed-header" *ngIf="msg.status !== ChatMessageStatus.COMPLETED">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#64748b"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="collapse-icon"
                  [class.rotated]="msg.isCollapsed"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
                <div class="header-text-container">
                  <span class="generating-title">
                    {{ msg.latestShimmerTitle }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Labels List (Grouped previous shimmer messages with timeline effect) -->
            <div class="shimmer-timeline timeline-group" *ngIf="!msg.isCollapsed">
              <!-- Show existing items from history -->
              <div class="timeline-item" *ngFor="let item of msg.shimmerGroup; let groupIdx = index; let isLast = last">
                <div class="timeline-visual">
                  <div class="timeline-dot">
                    <div class="dynamic-icon timeline-svg-wrapper" *ngIf="item.latestShimmerIcon">
                      <svg-icon
                        [src]="'assets/designIconLib/SVG/' + item.latestShimmerIcon + '.svg'"
                        [svgStyle]="{ 'width.px': 15, 'height.px': 15 }"
                      ></svg-icon>
                    </div>
                  </div>
                </div>
                <div class="shimmer-tl-content">
                  <div class="shimmer-label-item">
                    <span class="label-text">
                      {{ item.label || item.text }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- PLAN_OUTLINE Card -->
          <div
            class="artifacts-approval plan-outline-card d-none"
            *ngIf="msg.content && msg.messageType === ChatMessageType.PLAN_OUTLINE && !msg.isStreaming"
            [class.collapsed]="msg.isCollapsed"
          >
            <div
              class="plan-header-row"
              (click)="msg.status === ChatMessageStatus.COMPLETED && toggleMessageCollapse(msg)"
              (keydown.enter)="msg.status === ChatMessageStatus.COMPLETED && toggleMessageCollapse(msg)"
              (keydown.space)="msg.status === ChatMessageStatus.COMPLETED && toggleMessageCollapse(msg)"
              tabindex="0"
              [style.cursor]="msg.status === ChatMessageStatus.COMPLETED ? 'pointer' : 'default'"
              *ngIf="!msg.content.hideHeader"
            >
              <div class="plan-header-content" *ngIf="msg.content.header || msg.content?.sections?.length > 0">
                <div
                  class="todo-icon-wrapper"
                  *ngIf="msg?.content?.sections?.length > 1"
                  style="display: flex; align-items: center; margin-right: 4px"
                >
                  <svg-icon
                    *ngIf="msg.status === 'successful'"
                    [src]="'assets/designIconLib/SVG/check-circle.svg'"
                    [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"
                    class="{{ item.status }}"
                  ></svg-icon>
                  <app-spinner-icon
                    *ngIf="msg.status === 'in-progress'"
                    [size]="16"
                    class="{{ item.status }}"
                  ></app-spinner-icon>
                  <svg-icon
                    *ngIf="msg.status === 'failed'"
                    [src]="'assets/designIconLib/SVG/x-circle.svg'"
                    [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"
                    class="{{ item.status }}"
                  ></svg-icon>
                </div>
                <span *ngIf="msg.content.header?.title || msg.content?.sections?.length > 0">
                  <span class="static-prefix-label">{{
                    msg.content.header?.title || msg.content?.sections?.[0].title
                  }}</span>
                </span>
              </div>

              <div class="spacer"></div>

              <div class="msg-header-right">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="collapse-icon"
                  [class.rotated]="msg.isCollapsed"
                  *ngIf="msg.status === ChatMessageStatus.COMPLETED"
                >
                  <path d="m18 15-6-6-6 6" />
                </svg>
              </div>
            </div>

            <div class="plan-summary mt-2 mb-1" *ngIf="msg.content.description">
              {{ msg.content.description }}
            </div>

            <!-- List Display for Section (Non-editable, Card style) -->
            <div class="revision-tables-list single-section" *ngIf="msg.content?.sections?.length === 1">
              <div class="section-card-container single-section" *ngFor="let section of msg.content.sections">
                <div [class.display-none]="section.isCollapsed" class="section-items-container">
                  <div class="revision-table-item section-item-card" *ngFor="let item of section.items">
                    <div class="table-item-header" style="border: none">
                      <div class="table-title">
                        <div class="table-icon" style="display: flex; align-items: center; color: #6b7280">
                          <svg-icon
                            *ngIf="item.status === 'successful'"
                            [src]="'assets/designIconLib/SVG/check-circle.svg'"
                            [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"
                            class="{{ item.status }}"
                          ></svg-icon>
                          <app-spinner-icon
                            *ngIf="item.status === 'in-progress'"
                            [size]="16"
                            class="{{ item.status }}"
                          ></app-spinner-icon>
                          <svg-icon
                            *ngIf="item.status === 'failed'"
                            [src]="'assets/designIconLib/SVG/x-circle.svg'"
                            [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"
                            class="{{ item.status }}"
                          ></svg-icon>
                          <svg-icon
                            *ngIf="item.status === 'pending' || !item.status"
                            [src]="'assets/designIconLib/additions/dash-circle.svg'"
                            [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
                            class="{{ item.status }}"
                          ></svg-icon>
                        </div>
                        <span class="table-name status-{{ item.status }}">{{ item.text }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- In future, if need support for multiple sections, we can re-use it -->
            <!--
            <div class="revision-tables-list multiple-sections" *ngIf="msg.content?.sections?.length > 1">
              <div class="section-card-container multiple-sections" *ngFor="let section of msg.content.sections">
                <div
                  class="revision-section-header"
                  *ngIf="section.title"
                  (click)="section.isCollapsed = !section.isCollapsed"
                  (keydown.enter)="section.isCollapsed = !section.isCollapsed"
                  (keydown.space)="section.isCollapsed = !section.isCollapsed"
                  tabindex="0"
                  style="cursor: pointer; user-select: none; justify-content: space-between"
                >
                  <span style="flex: 1; pointer-events: none">{{ section.title }}</span>
                  <rt-icon-chevron-right
                    class="ml-1"
                    style="transition: transform 0.2s"
                    [style.transform]="section.isCollapsed ? 'rotate(90deg)' : 'rotate(270deg)'"
                    width="14"
                    height="14"
                  ></rt-icon-chevron-right>
                </div>
                <div [class.display-none]="section.isCollapsed" class="section-items-container">
                  <div class="revision-table-item section-item-card" *ngFor="let item of section.items">
                    <div class="table-item-header" style="border: none">
                      <div class="table-title">
                        <div class="table-icon" style="display: flex; align-items: center; color: #6b7280">
                          <svg-icon
                            *ngIf="item.status === 'successful'"
                            [src]="'assets/designIconLib/additions/dash-circle.svg'"
                            [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
                            class="{{ item.status }}"
                          ></svg-icon>
                          <app-spinner-icon *ngIf="item.status === 'in-progress'" [size]="15" class="{{ item.status }}"></app-spinner-icon>
                          <svg-icon
                            *ngIf="item.status === 'failed'"
                            [src]="'assets/designIconLib/SVG/x-circle.svg'"
                            [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
                            class="{{ item.status }}"
                          ></svg-icon>
                          <rt-icon-placeholder
                            *ngIf="item.status === 'pending' || !item.status"
                            width="18"
                            height="18"
                            class="{{ item.status }}"
                          ></rt-icon-placeholder>
                        </div>
                        <span class="table-name">{{ item.text }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            -->

            <!-- Footer section with buttons in plan card -->
            <div
              class="plan-footer"
              [class.disabled-state]="msg.isActionInProgress"
              *ngIf="
                activeSession.isOwner &&
                (msg.leftActions?.length || msg.rightActions?.length || msg.iconActions?.length) &&
                !msg.isCollapsed &&
                !msg.isStreaming &&
                msg.status !== ChatMessageStatus.COMPLETED
              "
            >
              <div class="footer-left">
                <ng-container *ngFor="let iconAction of msg.iconActions">
                  <button
                    class="reject-btn"
                    [pTooltip]="iconAction.label"
                    tooltipPosition="top"
                    [disabled]="
                      iconAction.disabled || msg.isActionInProgress || (isChangeMode && changeRequestMessageIndex === i)
                    "
                    (click)="handleMessageAction(iconAction, i)"
                  >
                    <!-- For now, we reuse app-file-x-icon for ANY action marked as renderAsIcon -->
                    <app-file-x-icon [size]="23"></app-file-x-icon>
                  </button>
                </ng-container>
                <button
                  *ngFor="let act of msg.leftActions"
                  class="action-btn left-action-btn"
                  [class.primary]="act.isPrimary"
                  [disabled]="act.disabled"
                  (click)="handleMessageAction(act, i)"
                >
                  {{ act.label }}
                </button>
              </div>
              <div class="spacer"></div>
              <div class="footer-right">
                <button
                  *ngFor="let act of msg.rightActions"
                  class="action-btn"
                  [class.primary]="act.isPrimary"
                  [disabled]="act.disabled"
                  (click)="handleMessageAction(act, i)"
                >
                  {{ act.label }}
                </button>
              </div>
            </div>
          </div>

          <!-- Plan Card (Artifacts proposal) -->
          <div
            class="plan-card artifacts-approval"
            *ngIf="msg.plan && msg.messageType === ChatMessageType.PLAN && !msg.isStreaming"
            [class.collapsed]="msg.isCollapsed"
          >
            <div
              class="plan-header-row"
              (click)="toggleMessageCollapse(msg)"
              (keydown.enter)="toggleMessageCollapse(msg)"
              (keydown.space)="toggleMessageCollapse(msg)"
              tabindex="0"
              [style.cursor]="msg.status === ChatMessageStatus.COMPLETED ? 'pointer' : 'default'"
            >
              <div class="plan-header-content" *ngIf="msg.plan.header">
                <!-- <app-spinner-icon [size]="16" *ngIf="msg.status !== ChatMessageStatus.COMPLETED"></app-spinner-icon>
                <ng-container *ngIf="msg.status === ChatMessageStatus.COMPLETED">
                  <app-blue-tick-icon [size]="16" *ngIf="msg.actionTaken?.code === 'accept'"></app-blue-tick-icon>

                  <app-file-x-icon
                    [size]="18"
                    style="color: #ff4d4f"
                    *ngIf="msg.actionTaken?.code === 'reject'"
                  ></app-file-x-icon>
                
                  <i
                    *ngIf="msg.actionTaken?.code === 'refine'"
                    class="pi pi-exclamation-triangle"
                    style="font-size: 16px !important; color: #ffa500"
                  ></i>
                </ng-container> -->
                <span class="plan-header-label" *ngIf="msg.plan.header.title">{{ msg.plan.header.title }}</span>
              </div>
              <div class="spacer"></div>
              <div class="msg-header-right">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="collapse-icon"
                  [class.completed-collapsed]="msg.isCollapsed"
                >
                  <path d="m18 15-6-6-6 6" />
                </svg>
              </div>
            </div>

            <div class="plan-summary" *ngIf="msg.plan.summaryText">
              {{ msg.plan.summaryText }}
            </div>

            <div class="plan-summary" *ngIf="msg.plan.description">
              {{ msg.plan.description }}
            </div>

            <!--

              Categories Summary Container

              Hard-coded sequence(Not Alphabetical)

            -->
            <div
              class="artifact-summary-container mb-2"
              *ngIf="!msg.isCollapsed && msg.treeTableData && msg.treeTableData.length > 0"
            >
              <div
                class="artifact-summary-row mb-1"
                *ngIf="getFilteredNodes(msg.treeTableData, 'datamodel').length > 0"
              >
                <span class="artifact-summary-label">
                  <rt-icon-database-02 width="16" height="16"></rt-icon-database-02>
                  Data Model
                </span>
                <button
                  class="visualizer-btn"
                  title="View Data Model Visualizer"
                  [disabled]="msg.status === ChatMessageStatus.COMPLETED"
                  (click)="openDataModelWithVisualizer(msg.sid)"
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                    <polyline points="15 3 21 3 21 9"></polyline>
                    <line x1="10" y1="14" x2="21" y2="3"></line>
                  </svg>
                  <span class="btn-text">Open</span>
                </button>
              </div>
              <div class="artifact-summary-row mb-1" *ngIf="getFilteredNodes(msg.treeTableData, 'page').length > 0">
                <span class="artifact-summary-label">
                  <app-page-icon [size]="16"></app-page-icon>
                  Pages
                </span>
                <button
                  class="visualizer-btn"
                  title="View Page Visualizer"
                  [disabled]="msg.status === ChatMessageStatus.COMPLETED"
                  (click)="openPageVisualizer(msg.sid)"
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                    <polyline points="15 3 21 3 21 9"></polyline>
                    <line x1="10" y1="14" x2="21" y2="3"></line>
                  </svg>
                  <span class="btn-text">Open</span>
                </button>
              </div>
            </div>

            <!-- List Display for Plan (Non-editable, Card style) -->
            <div class="revision-tables-list display-none" *ngIf="msg.treeTableData && msg.treeTableData.length > 0">
              <!-- Data Models Section -->
              <ng-container *ngIf="getFilteredNodes(msg.treeTableData, 'datamodel').length > 0">
                <div class="revision-section-header">
                  <span>Data Model</span>
                </div>
                <div
                  class="revision-table-item table-item-expanded-{{ tableNode.expanded }}"
                  *ngFor="let tableNode of getFilteredNodes(msg.treeTableData, 'datamodel')"
                >
                  <div class="table-item-header">
                    <div
                      class="table-title"
                      [class.is-update-title]="tableNode.data.isUpdate && tableNode.data.oldTableName"
                    >
                      <rt-icon-database-02 width="16" height="16" class="table-icon"></rt-icon-database-02>
                      <div class="table-name-wrapper">
                        <span
                          class="table-name"
                          [class.is-table-deleted]="tableNode.data.isTableDelete"
                          [pTooltip]="tableNode.data.name"
                          tooltipPosition="top"
                          >{{ tableNode.data.name }}</span
                        >
                        <span
                          class="table-name old-table-name"
                          *ngIf="tableNode.data.isUpdate && tableNode.data.oldTableName"
                          [pTooltip]="tableNode.data.oldTableName"
                          tooltipPosition="top"
                          >{{ tableNode.data.oldTableName }}</span
                        >
                      </div>
                    </div>
                    <div class="status-dot-container">
                      <button
                        *ngIf="!tableNode.data.isTableDelete && tableNode.children && tableNode.children.length > 0"
                        class="toggle-fields-btn"
                        (click)="toggleNode(tableNode, i)"
                      >
                        {{ tableNode.expanded ? 'Hide fields' : 'Show fields' }}
                      </button>
                      <div class="dots-wrapper">
                        <ng-container *ngIf="!tableNode.data.isUpdate; else updateDots">
                          <div class="status-dot"></div>
                        </ng-container>
                        <ng-template #updateDots>
                          <div *ngIf="tableNode.data.hasDelete" class="status-dot is-delete"></div>
                          <div *ngIf="tableNode.data.hasEdit" class="status-dot is-update"></div>
                          <div *ngIf="tableNode.data.hasAdd" class="status-dot has-add-op"></div>
                          <div
                            *ngIf="
                              !tableNode.data.hasAdd &&
                              !tableNode.data.hasEdit &&
                              !tableNode.data.hasDelete &&
                              tableNode.data.oldTableName
                            "
                            class="status-dot is-update"
                          ></div>
                        </ng-template>
                      </div>
                    </div>
                  </div>

                  <div class="table-fields-list" *ngIf="tableNode.expanded && tableNode.children">
                    <div class="field-item" *ngFor="let fieldNode of tableNode.children">
                      <ng-container *ngIf="fieldNode.data.isField">
                        <span
                          class="field-bullet"
                          [class.is-changed-field]="
                            tableNode.data.isUpdate && fieldNode.data.isNew === false && !fieldNode.data.isDelete
                          "
                          [class.is-deleted-field]="tableNode.data.isUpdate && fieldNode.data.isDelete"
                          >•</span
                        >
                        <span
                          class="field-name"
                          [class.is-changed-field]="
                            tableNode.data.isUpdate && fieldNode.data.isNew === false && !fieldNode.data.isDelete
                          "
                          [class.is-deleted-field]="tableNode.data.isUpdate && fieldNode.data.isDelete"
                          [pTooltip]="
                            fieldNode.data.oldName
                              ? fieldNode.data.oldName + ' ➔ ' + fieldNode.data.name
                              : fieldNode.data.name
                          "
                          tooltipPosition="top"
                        >
                          {{ fieldNode.data.name }}
                          <ng-container *ngIf="fieldNode.data.oldName">
                            <span style="text-decoration: line-through; opacity: 0.7; margin-left: 6px">{{
                              fieldNode.data.oldName
                            }}</span>
                          </ng-container>
                        </span>
                        <span class="spacer"></span>
                        <span
                          *ngIf="!fieldNode.data.isDelete"
                          class="field-type-badge"
                          [class.is-changed-field]="
                            tableNode.data.isUpdate && fieldNode.data.isNew === false && !fieldNode.data.isDelete
                          "
                          >{{ fieldNode.data.type }}</span
                        >
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- Pages Section -->
              <ng-container *ngIf="getFilteredNodes(msg.treeTableData, 'page').length > 0">
                <div class="revision-section-header">Pages</div>
                <div class="revision-table-item" *ngFor="let tableNode of getFilteredNodes(msg.treeTableData, 'page')">
                  <div class="table-item-header">
                    <div class="table-title">
                      <app-page-icon [size]="16" class="table-icon"></app-page-icon>
                      <div class="table-name-wrapper">
                        <span class="table-name" [pTooltip]="tableNode.data.name" tooltipPosition="top">{{
                          tableNode.data.name
                        }}</span>
                      </div>
                    </div>
                    <!-- Pages might not have 'fields' in the same way, but keeping toggle if they have children -->
                    <div class="status-dot-container">
                      <!-- <button
                        class="toggle-fields-btn"
                        (click)="toggleNode(tableNode, i)"
                      >
                        {{ tableNode.expanded ? 'Hide structure' : 'Show structure' }}
                      </button> -->
                      <div class="status-dot"></div>
                    </div>
                  </div>

                  <div class="table-fields-list" *ngIf="tableNode.expanded && tableNode.children">
                    <div class="field-item" *ngFor="let fieldNode of tableNode.children">
                      <ng-container *ngIf="fieldNode.data.isField">
                        <span class="field-bullet">•</span>
                        <span class="field-name" [pTooltip]="fieldNode.data.name" tooltipPosition="top">{{
                          fieldNode.data.name
                        }}</span>
                        <span class="spacer"></span>
                        <span class="field-type-badge">{{ fieldNode.data.type }}</span>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>

            <!-- Footer section with buttons in plan card -->
            <div
              class="plan-footer"
              [class.disabled-state]="msg.isActionInProgress"
              *ngIf="
                activeSession.isOwner &&
                (msg.leftActions?.length || msg.rightActions?.length || msg.iconActions?.length) &&
                !msg.isCollapsed &&
                !msg.isStreaming &&
                msg.status !== ChatMessageStatus.COMPLETED
              "
            >
              <div class="footer-left">
                <ng-container *ngFor="let iconAction of msg.iconActions">
                  <button
                    class="reject-btn"
                    [pTooltip]="iconAction.label"
                    tooltipPosition="top"
                    [disabled]="
                      iconAction.disabled || msg.isActionInProgress || (isChangeMode && changeRequestMessageIndex === i)
                    "
                    (click)="handleMessageAction(iconAction, i)"
                  >
                    <!-- For now, we reuse app-file-x-icon for ANY action marked as renderAsIcon -->
                    <app-file-x-icon [size]="23"></app-file-x-icon>
                  </button>
                </ng-container>
                <button
                  *ngFor="let act of msg.leftActions"
                  class="action-btn left-action-btn"
                  [class.primary]="act.isPrimary"
                  [disabled]="act.disabled"
                  (click)="handleMessageAction(act, i)"
                >
                  {{ act.label }}
                </button>
              </div>
              <div class="spacer"></div>
              <div class="footer-right">
                <button
                  *ngFor="let act of msg.rightActions"
                  class="action-btn"
                  [class.primary]="act.isPrimary"
                  [disabled]="act.disabled"
                  (click)="handleMessageAction(act, i)"
                >
                  {{ act.label }}
                </button>
              </div>
            </div>
          </div>

          <!-- Message Timestamp & Copy Actions -->
          <div
            class="message-actions d-flex align-items-center"
            *ngIf="
              msg.messageType !== ChatMessageType.SHIMMER &&
              msg.showServerMessageOptions !== false &&
              (msg.type === 'user' || msg.showSpeedometer)
            "
            [ngClass]="msg.type === 'user' ? 'justify-content-end' : 'justify-content-start'"
          >
            <div class="user-actions d-flex align-items-center" *ngIf="msg.type === 'user' && msg.createdDate">
              <rt-icon-copy-03
                width="14"
                height="14"
                class="cursor-pointer"
                (click)="copyToClipboard(getCopyText(msg))"
                [title]="'COPY_MESSAGE' | translate"
              ></rt-icon-copy-03>
              <span class="timestamp" [appRefreshTimeAgo]="msg.createdDate"></span>
            </div>

            <div class="server-actions d-flex align-items-center" *ngIf="msg.type !== 'user' && msg.text">
              <rt-icon-copy-03
                *ngIf="msg.showSpeedometer && !msg.isStreaming"
                width="14"
                height="14"
                class="cursor-pointer action-icon"
                (click)="copyConversationToClipboard(i)"
                [title]="'COPY_MESSAGE' | translate"
              ></rt-icon-copy-03>
              <rt-icon-speedometer-03
                *ngIf="msg.showSpeedometer && !msg.isStreaming"
                width="14"
                height="14"
                class="action-icon"
                [title]="msg.speedometerTooltip"
              ></rt-icon-speedometer-03>
            </div>
          </div>
        </div>

        <!-- Working Indicator -->
      </div>

      <!-- Session List Box (Displayed at top due to column-reverse) -->
      <div class="sessions-selection" *ngIf="!isLoadingSessions && isSessionsPanelOpen">
        <!-- INBOX HEADER -->
        <div class="inbox-header mb-4">
          <div class="d-flex align-items-center justify-content-between">
            <div class="inbox-title">
              <h2 class="m-0" style="font-size: 16px; font-weight: 600; color: #0f172a">Inbox</h2>
            </div>
            <div class="inbox-actions d-flex align-items-center gap-2">
              <button
                class="icon-btn d-flex align-items-center justify-content-center p-2 border-0 cursor-pointer"
                (click)="isSessionSearchVisible = !isSessionSearchVisible; sessionSearchQuery = ''"
              >
                <rt-icon-search-md width="15" height="15"></rt-icon-search-md>
              </button>

              <div class="filter-dropdown-container position-relative">
                <button
                  class="icon-btn d-flex align-items-center justify-content-center p-2 border-0 cursor-pointer"
                  (click)="filterOverlay.toggle($event)"
                >
                  <rt-icon-filter-lines width="15" height="15"></rt-icon-filter-lines>
                </button>

                <p-overlayPanel
                  #filterOverlay
                  appendTo="body"
                  styleClass="session-inbox-filter-overlay"
                  [style]="{ padding: '0', background: 'transparent', 'box-shadow': 'none' }"
                >
                  <ng-template pTemplate="content">
                    <div class="custom-inbox-menu bg-white p-1">
                      <!-- Header -->
                      <div
                        class="d-flex align-items-center justify-content-between px-2 py-2 mb-1"
                        style="border-bottom: 1px solid #f1f5f9"
                      >
                        <div class="d-flex align-items-center">
                          <span style="font-size: 14px; font-weight: 400; color: #3b82f6">Filters</span>
                          <span
                            class="badge"
                            *ngIf="filterBadgeCount > 0"
                            style="color: #3b82f6; font-size: 11px; margin-left: 4px; font-weight: 700"
                            >{{ filterBadgeCount }}</span
                          >
                        </div>
                        <span
                          *ngIf="filterBadgeCount > 0"
                          class="cursor-pointer reset-link"
                          style="font-size: 13px; font-weight: 500; color: #3b82f6"
                          (click)="resetFilters()"
                          tabindex="0"
                          (keydown.enter)="resetFilters()"
                          >Reset</span
                        >
                      </div>

                      <!-- Session Type -->
                      <div class="c-menu-item has-submenu session-type">
                        <div class="d-flex align-items-center filter-item">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#64748b"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                          </svg>
                          <span class="filter-label">Session Type</span>
                        </div>
                        <rt-icon-chevron-right width="12" height="12"></rt-icon-chevron-right>

                        <div class="c-submenu">
                          <div
                            class="c-sub-item"
                            role="button"
                            (click)="toggleByType('ideation')"
                            tabindex="0"
                            (keydown.enter)="toggleByType('ideation')"
                          >
                            <div class="d-flex align-items-center filter-item">
                              <rt-light-bulb-icon width="15" height="15"></rt-light-bulb-icon>
                              <span class="filter-label">Ideate</span>
                            </div>
                            <svg
                              *ngIf="activeFilters.type.has('ideation')"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#3b82f6"
                              stroke-width="2"
                            >
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          </div>
                          <div
                            class="c-sub-item"
                            role="button"
                            (click)="toggleByType('build_auto')"
                            tabindex="0"
                            (keydown.enter)="toggleByType('build_auto')"
                          >
                            <div class="d-flex align-items-center filter-item">
                              <rt-icon-cube-01 width="15" height="15"></rt-icon-cube-01>
                              <span class="filter-label">Build</span>
                            </div>
                            <svg
                              *ngIf="activeFilters.type.has('build_auto')"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#3b82f6"
                              stroke-width="2"
                            >
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          </div>
                          <div
                            class="c-sub-item"
                            role="button"
                            (click)="toggleByType('build_manual')"
                            tabindex="0"
                            (keydown.enter)="toggleByType('build_manual')"
                          >
                            <div class="d-flex align-items-center filter-item">
                              <rt-icon-message-text-square-01 width="15" height="15"></rt-icon-message-text-square-01>
                              <span class="filter-label">Chat</span>
                            </div>
                            <svg
                              *ngIf="activeFilters.type.has('build_manual')"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#3b82f6"
                              stroke-width="2"
                            >
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          </div>
                        </div>
                      </div>

                      <!-- Session Status -->
                      <div class="c-menu-item has-submenu session-status">
                        <div class="d-flex align-items-center filter-item">
                          <rt-icon-status></rt-icon-status>
                          <span class="filter-label">Session Status</span>
                        </div>
                        <rt-icon-chevron-right width="12" height="12"></rt-icon-chevron-right>

                        <div class="c-submenu">
                          <div
                            class="c-sub-item"
                            role="button"
                            (click)="toggleByMergeStatus(SESSION_MERGE_STATUS.YET_TO_START)"
                            tabindex="0"
                            (keydown.enter)="toggleByMergeStatus(SESSION_MERGE_STATUS.YET_TO_START)"
                          >
                            <span style="font-weight: 400">Open</span>
                            <svg
                              *ngIf="activeFilters.mergeStatus.has(SESSION_MERGE_STATUS.YET_TO_START)"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#3b82f6"
                              stroke-width="2"
                            >
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          </div>
                          <div
                            class="c-sub-item"
                            role="button"
                            (click)="toggleByMergeStatus(SESSION_MERGE_STATUS.IN_PROGRESS)"
                            tabindex="0"
                            (keydown.enter)="toggleByMergeStatus(SESSION_MERGE_STATUS.IN_PROGRESS)"
                          >
                            <span style="font-weight: 400">In progress</span>
                            <svg
                              *ngIf="activeFilters.mergeStatus.has(SESSION_MERGE_STATUS.IN_PROGRESS)"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#3b82f6"
                              stroke-width="2"
                            >
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          </div>
                          <div
                            class="c-sub-item"
                            role="button"
                            (click)="toggleByMergeStatus(SESSION_MERGE_STATUS.SUCCESS)"
                            tabindex="0"
                            (keydown.enter)="toggleByMergeStatus(SESSION_MERGE_STATUS.SUCCESS)"
                          >
                            <span style="font-weight: 400">Completed</span>
                            <svg
                              *ngIf="activeFilters.mergeStatus.has(SESSION_MERGE_STATUS.SUCCESS)"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#3b82f6"
                              stroke-width="2"
                            >
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          </div>
                          <div
                            class="c-sub-item"
                            role="button"
                            (click)="toggleByMergeStatus(SESSION_MERGE_STATUS.FAILED)"
                            tabindex="0"
                            (keydown.enter)="toggleByMergeStatus(SESSION_MERGE_STATUS.FAILED)"
                          >
                            <span style="font-weight: 400">Failed</span>
                            <svg
                              *ngIf="activeFilters.mergeStatus.has(SESSION_MERGE_STATUS.FAILED)"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#3b82f6"
                              stroke-width="2"
                            >
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          </div>
                        </div>
                      </div>

                      <!-- Filter by Owner -->
                      <div class="c-menu-item has-submenu session-owner">
                        <div class="d-flex align-items-center filter-item">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#64748b"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                            <circle cx="12" cy="7" r="4"></circle>
                          </svg>
                          <span class="filter-label">Filter by owner</span>
                        </div>
                        <rt-icon-chevron-right width="12" height="12"></rt-icon-chevron-right>

                        <div class="c-submenu" style="padding: 4px; min-width: 240px">
                          <!-- Owner Search Input -->
                          <div class="px-1 py-1 mb-2 mt-1 position-relative d-flex align-items-center">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#64748b"
                              stroke-width="2"
                              style="position: absolute; left: 12px"
                            >
                              <circle cx="11" cy="11" r="7"></circle>
                              <path d="M20 20L17 17"></path>
                            </svg>
                            <input
                              type="text"
                              placeholder="Search users"
                              class="w-100 outline-none"
                              autocomplete="off"
                              [(ngModel)]="ownerSearchQuery"
                              style="
                                background: transparent;
                                font-size: 13px;
                                color: #334155;
                                padding: 4px 28px;
                                width: 100%;
                                border-radius: 8px;
                                outline: 0;
                                border: 1px solid var(--neutral-300);
                              "
                            />
                            <svg
                              *ngIf="ownerSearchQuery"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#64748b"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="cursor-pointer"
                              style="position: absolute; right: 8px"
                              (click)="ownerSearchQuery = ''"
                              tabindex="0"
                              (keydown.enter)="ownerSearchQuery = ''"
                            >
                              <line x1="18" y1="6" x2="6" y2="18"></line>
                              <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                          </div>

                          <!-- Selected Owners Group -->
                          <ng-container *ngIf="selectedOwnerItems.length > 0">
                            <div
                              class="px-2 py-1 mb-1 d-flex align-items-center"
                              style="font-size: 12px; font-weight: 500; color: var(--neutral-800)"
                            >
                              Selected
                              <span
                                class="badge"
                                style="
                                  background: var(--neutral-100);
                                  font-size: 0.9rem;
                                  color: var(--neutral-600);
                                  border-radius: 8px;
                                  padding: 4px 8px;
                                  margin-left: 6px;
                                "
                                >{{ selectedOwnerItems.length }}</span
                              >
                            </div>
                            <ng-container *ngFor="let owner of selectedOwnerItems; trackBy: trackByOwner">
                              <ng-container
                                *ngTemplateOutlet="ownerItemTemplate; context: { $implicit: owner }"
                              ></ng-container>
                            </ng-container>

                            <!-- Divider after selected group -->
                            <div
                              *ngIf="unselectedFilteredOwnerItems.length > 0"
                              style="height: 1px; background-color: #f1f5f9; margin: 4px 8px 8px 8px"
                            ></div>
                          </ng-container>

                          <!-- Results / Unselected Owners Group -->
                          <div
                            *ngIf="ownerSearchQuery && unselectedFilteredOwnerItems.length > 0"
                            class="px-2 py-1 mb-1 mt-1 d-flex align-items-center"
                            style="
                              font-size: 11px;
                              font-weight: 600;
                              color: #64748b;
                              text-transform: uppercase;
                              letter-spacing: 0.5px;
                            "
                          >
                            Results
                          </div>

                          <ng-container *ngIf="unselectedFilteredOwnerItems.length > 0">
                            <ng-container *ngFor="let owner of unselectedFilteredOwnerItems; trackBy: trackByOwner">
                              <ng-container
                                *ngTemplateOutlet="ownerItemTemplate; context: { $implicit: owner }"
                              ></ng-container>
                            </ng-container>
                          </ng-container>

                          <!-- No Results Fallback -->
                          <div
                            *ngIf="
                              ownerSearchQuery &&
                              unselectedFilteredOwnerItems.length === 0 &&
                              selectedOwnerItems.length === 0
                            "
                            class="px-2 py-1"
                            style="font-size: 13px; color: #64748b"
                          >
                            No Results
                          </div>

                          <!-- Reusable Owner Item Template -->
                          <ng-template #ownerItemTemplate let-owner>
                            <div
                              role="button"
                              class="c-sub-item px-2 py-1 mb-1"
                              (click)="toggleByOwner(owner.id)"
                              tabindex="0"
                              (keydown.enter)="toggleByOwner(owner.id)"
                            >
                              <div class="d-flex align-items-center" style="gap: 12px; overflow: hidden">
                                <div
                                  class="avatar-circle"
                                  [style.background]="owner.color.bg"
                                  [style.color]="owner.color.text"
                                  style="
                                    width: 24px;
                                    height: 24px;
                                    border-radius: 50%;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 12px;
                                    font-weight: 500;
                                    flex-shrink: 0;
                                  "
                                >
                                  {{ owner.letter }}
                                </div>
                                <span class="text-truncate" style="font-weight: 400">{{ owner.name }}</span>
                              </div>
                              <svg
                                *ngIf="activeFilters.owner.has(owner.id)"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#3b82f6"
                                stroke-width="2"
                                style="flex-shrink: 0"
                              >
                                <polyline points="20 6 9 17 4 12"></polyline>
                              </svg>
                            </div>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </p-overlayPanel>
              </div>
            </div>
          </div>

          <!-- SEARCH BOX -->
          <div class="session-search-wrapper mt-3" *ngIf="isSessionSearchVisible">
            <div
              class="position-relative d-flex align-items-center"
              style="
                background: #ffffff;
                border: 1px solid #cbd5e1;
                border-radius: 8px;
                padding: 4px 10px;
                height: 38px;
              "
            >
              <rt-icon-search-md
                width="16"
                height="16"
                class="text-secondary opacity-75 mr-2"
                style="flex-shrink: 0"
              ></rt-icon-search-md>
              <input
                type="text"
                placeholder="Search"
                class="w-100 border-0 outline-none p-0"
                autocomplete="off"
                [(ngModel)]="sessionSearchQuery"
                style="box-shadow: none; outline: none; background: transparent; font-size: 14px; color: #334155"
              />
              <rt-icon-close
                width="16"
                height="16"
                *ngIf="sessionSearchQuery"
                class="cursor-pointer text-secondary opacity-75"
                style="flex-shrink: 0; margin-left: 6px"
                (click)="sessionSearchQuery = ''"
                (keydown.enter)="sessionSearchQuery = ''"
              ></rt-icon-close>
            </div>
          </div>
        </div>

        <!-- SEARCH RESULTS SECTION -->
        <ng-container *ngIf="sessionSearchQuery">
          <div class="sessions-header d-flex mb-3">
            <span class="session-group-title mr-2">{{ 'SEARCH_RESULTS' | translate }}</span>
          </div>

          <div class="sessions-grid">
            <div *ngIf="searchResultsSessions.length === 0" class="text-secondary" style="font-size: 13px">
              No results found
            </div>
            <ng-container *ngFor="let session of searchResultsSessions; trackBy: trackBySession">
              <ng-container *ngTemplateOutlet="sessionChipTemplate; context: { $implicit: session }"></ng-container>
            </ng-container>
          </div>
        </ng-container>

        <!-- PINNED SESSIONS -->
        <ng-container *ngIf="!sessionSearchQuery && pinnedSessions && pinnedSessions.length > 0">
          <div class="sessions-header d-flex mb-2">
            <span
              class="session-group-title mr-2 cursor-pointer"
              (click)="isPinnedSessionsCollapsed = !isPinnedSessionsCollapsed"
              (keydown.enter)="isPinnedSessionsCollapsed = !isPinnedSessionsCollapsed"
              tabindex="0"
              >{{ 'PINNED' | translate }}</span
            >
            <rt-icon-chevron-right
              width="12"
              height="12"
              [class.rotated]="!isPinnedSessionsCollapsed"
              class="d-flex collapse-icon cursor-pointer"
              (click)="isPinnedSessionsCollapsed = !isPinnedSessionsCollapsed"
              (keydown.enter)="isPinnedSessionsCollapsed = !isPinnedSessionsCollapsed"
            ></rt-icon-chevron-right>
          </div>
          <div class="sessions-grid pinned-sessions mb-4" *ngIf="!isPinnedSessionsCollapsed">
            <ng-container *ngFor="let session of pinnedSessions; trackBy: trackBySession">
              <ng-container *ngTemplateOutlet="sessionChipTemplate; context: { $implicit: session }"></ng-container>
            </ng-container>
          </div>
        </ng-container>

        <!-- OTHER SESSIONS -->
        <ng-container *ngIf="!sessionSearchQuery">
          <div class="sessions-header d-flex mb-2">
            <span
              (click)="isOtherSessionsCollapsed = !isOtherSessionsCollapsed"
              (keydown.enter)="isOtherSessionsCollapsed = !isOtherSessionsCollapsed"
              class="session-group-title mr-2 cursor-pointer"
              tabindex="0"
              >{{ 'SESSIONS' | translate }}</span
            >
            <rt-icon-chevron-right
              width="12"
              height="12"
              [class.rotated]="!isOtherSessionsCollapsed"
              class="d-flex collapse-icon cursor-pointer"
              (click)="isOtherSessionsCollapsed = !isOtherSessionsCollapsed"
              (keydown.enter)="isOtherSessionsCollapsed = !isOtherSessionsCollapsed"
            ></rt-icon-chevron-right>
          </div>

          <div class="sessions-tabs d-flex align-items-center mb-2" *ngIf="!isOtherSessionsCollapsed">
            <button class="session-tab-btn" [class.active]="sessionsTab === 'self'" (click)="setSessionsTab('self')">
              <span>{{ 'MY_SESSIONS' | translate }}</span>
            </button>
            <button class="session-tab-btn" [class.active]="sessionsTab === 'all'" (click)="setSessionsTab('all')">
              <span>{{ 'ALL_SESSIONS' | translate }}</span>
            </button>
          </div>

          <div class="sessions-grid" *ngIf="!isOtherSessionsCollapsed">
            <div *ngIf="displayedSessions.length === 0">
              <ng-container *ngTemplateOutlet="noSessionsTemplate"></ng-container>
            </div>
            <ng-container *ngFor="let session of displayedSessions; trackBy: trackBySession">
              <ng-container *ngTemplateOutlet="sessionChipTemplate; context: { $implicit: session }"></ng-container>
            </ng-container>
          </div>
        </ng-container>

        <ng-template #noSessionsTemplate>
          <div>No sessions exist</div>
        </ng-template>

        <!-- REUSABLE SESSION CHIP TEMPLATE -->
        <ng-template #sessionChipTemplate let-session>
          <div class="session-chip" *ngIf="!session.isHidden">
            <div
              class="chip-content"
              (click)="selectSession(session)"
              (keydown.enter)="selectSession(session)"
              tabindex="0"
            >
              <span class="session-name" [title]="session.sessionName">
                <rt-light-bulb-icon
                  *ngIf="session.mode === SESSION_MODE.IDEATE"
                  width="15"
                  height="15"
                  class="d-flex"
                ></rt-light-bulb-icon>

                <rt-icon-message-text-square-01
                  *ngIf="session.mode === SESSION_MODE.BUILD && session.driven === SESSION_DRIVEN_MODE.MANUAL"
                  width="15"
                  height="15"
                  class="d-flex"
                ></rt-icon-message-text-square-01>

                <rt-icon-cube-01
                  *ngIf="session.mode === SESSION_MODE.BUILD && session.driven === SESSION_DRIVEN_MODE.AUTO"
                  width="15"
                  height="15"
                  class="d-flex"
                ></rt-icon-cube-01>

                <span class="text-truncate">{{ session.sessionName }}</span>
              </span>
              <div class="session-meta text-neutral-700">
                <span
                  class="creator-name text-truncate"
                  [title]="appMetaInfo[session.createdBy] || session.userEmail"
                  >{{ appMetaInfo[session.createdBy] || session.userEmail }}</span
                >
                <span class="session-date">{{ session.modifiedDate | timeAgo }}</span>
              </div>
            </div>
            <div
              class="session-actions"
              (click)="$event.stopPropagation()"
              (keydown.enter)="$event.stopPropagation()"
              tabindex="0"
            >
              <button
                class="icon-btn action-icon p-button-rounded p-button-text p-button-sm"
                (click)="listMenu.toggle($event)"
                (keydown.enter)="listMenu.toggle($event)"
                title="More Options"
                tabindex="0"
              >
                <i class="pi pi-ellipsis-v"></i>
              </button>
              <p-menu
                #listMenu
                [model]="session.menuItems"
                [popup]="true"
                appendTo="body"
                styleClass="session-kebab-menu"
              ></p-menu>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Floating Rai Avatar pinned to bottom of chat body / top of QnA -->
    <div
      class="floating-rai-wrapper"
      *ngIf="
        !isChatCollapsed &&
        !isSessionsPanelOpen &&
        ((activeSession?.isOwner &&
          (activeSession?.mergeStatus === SESSION_MERGE_STATUS.YET_TO_START ||
            activeSession?.mergeStatus === SESSION_MERGE_STATUS.FAILED) &&
          !isChatDisabled &&
          !isChangeMode) ||
          isNewSessionActive)
      "
    >
      <img
        src="assets/images/gif/rai-face-animated.gif"
        class="assistant-icon floating-rai-icon"
        tabindex="0"
        alt="Rai"
      />
    </div>

    <!-- QnA card docked permanently between chat-body and chat-footer -->
    <div class="session-qa-animation-wrapper" [class.qa-visible]="isQnACardVisible" *ngIf="activeSession.sid">
      <div class="session-qa-inline-overflow">
        <div class="session-qa-inline">
          <rt-qna-question-card
            [chatMessage]="QnAChatMessage"
            (formClose)="closeQnACard()"
            [activeSession]="activeSession"
            [appDetail]="appDetail"
            (formSubmit)="onSubmitQnACard($event)"
          >
          </rt-qna-question-card>
        </div>
      </div>
    </div>

    <div class="chat-footer" *ngIf="!isSessionsPanelOpen" [class.d-none]="isQnACardVisible">
      <!-- Session Approve/Discard Confirmation Banner -->
      <div class="ideate-confirmation-card artifacts-approval fade-in mb-2" *ngIf="isSessionConfirmationPending">
        <div class="plan-header-row" tabindex="0">
          <div class="plan-header-content">
            <app-spinner-icon [size]="16" class="mr-2"></app-spinner-icon>

            <span class="plan-header-label" *ngIf="sessionConfirmationType === 'reject'">
              {{ 'DISCARD_SESSION' | translate }}
            </span>
            <span class="plan-header-label" *ngIf="sessionConfirmationType === 'approve'">
              {{ 'APPROVE_SESSION' | translate }}
            </span>
          </div>
          <div class="spacer"></div>
        </div>

        <ng-container *ngIf="sessionConfirmationType === 'reject'">
          <div class="plan-summary mb-2">
            {{ 'DISCARD_SESSION_WARNING' | translate }}
          </div>

          <div class="plan-summary mb-1 pt-2">
            {{ 'DISCARD_SESSION_CONFIRMATION' | translate }}
          </div>
        </ng-container>

        <ng-container *ngIf="sessionConfirmationType === 'approve'">
          <div class="plan-summary mb-2" *ngIf="activeSession?.summary">
            {{ activeSession?.summary }}
          </div>

          <div class="plan-summary pt-2">
            {{ 'APPROVE_SESSION_CONFIRMATION' | translate }}
          </div>
        </ng-container>

        <!-- Footer section with buttons in plan card -->
        <div class="plan-footer">
          <div class="footer-left"></div>
          <div class="spacer"></div>
          <div class="footer-right">
            <button class="action-btn" (click)="resolveSessionConfirmation(false)">{{ 'NO' | translate }}</button>
            <button class="action-btn primary" (click)="resolveSessionConfirmation(true)">
              {{ 'YES' | translate }}
            </button>
          </div>
        </div>
      </div>

      <!-- Build Session Banner -->
      <div
        class="chat-input-container session-readonly-container build-session-banner"
        *ngIf="activeSession?.isBuildSessionInitiated"
      >
        <span>{{ 'BUILD_SESSION_TRIGGERED_INFO' | translate }}</span>
      </div>

      <!-- Build Session Confirmation Card -->
      <div
        class="chat-input-container session-readonly-container build-session-confirmation"
        *ngIf="
          activeSession?.isOwner &&
          activeSession?.mergeStatus === SESSION_MERGE_STATUS.SUCCESS &&
          activeSession?.isBuildSessionInitiated === false
        "
      >
        <span>{{ 'BUILD_SESSION_CONFIRMATION' | translate }}</span>
        <div class="confirmation-actions">
          <button class="action-btn" (click)="onDiscardBuildSession()">{{ 'NO' | translate }}</button>
          <button class="action-btn primary" (click)="onAcceptBuildSession()">{{ 'YES' | translate }}</button>
        </div>
      </div>

      <!-- Merge In Progress overlay -->
      <div
        class="chat-input-container session-readonly-container warning-100 text-neutral-900"
        *ngIf="activeSession?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS"
      >
        <span>{{ 'SESSION_MERGE_IN_PROGRESS_INFO' | translate }}</span>
      </div>

      <!-- Merge Failed overlay -->
      <div
        class="chat-input-container session-readonly-container error-100 text-neutral-900 mb-1"
        *ngIf="activeSession?.mergeStatus === SESSION_MERGE_STATUS.FAILED"
      >
        <span>{{ 'SESSION_MERGE_FAILED_INFO' | translate }}</span>
      </div>

      <!-- Readonly state overlay -->
      <div class="chat-input-container session-readonly-container warning-100 text-neutral-900 d-none">
        <span class="readonly-badge">{{ 'READ_ONLY_BADGE' | translate }}</span>
        <span [innerHTML]="'VIEWING_SESSION_OF_USER' | translate: { user: getViewingSessionUser() }"></span>
      </div>

      <div
        class="chat-input-container"
        *ngIf="
          (activeSession.status === SESSION_STATUS.ACTIVE || activeSession.isOwner || isNewSessionActive) &&
          !isQnADomStateActive
        "
      >
        <!-- #1 MIRROR_SHIMMER - message bar -->
        <div class="mb-2 mirror-shimmer" *ngIf="activeShimmerMessage">
          <img src="assets/images/gif/rai-face-animated.gif" class="assistant-icon" alt="Rai" />

          <div class="shimmer-text-container">
            <div class="shimmer-text-wrapper d-flex">
              <div class="icon-holder">
                <div class="dynamic-icon" *ngIf="activeShimmerMessage.latestShimmerIcon">
                  <svg-icon
                    [src]="'assets/designIconLib/SVG/' + activeShimmerMessage.latestShimmerIcon + '.svg'"
                    [svgStyle]="{ 'width.px': 15, 'height.px': 15 }"
                  ></svg-icon>
                </div>
              </div>
              <span [title]="activeShimmerMessage.latestShimmerLabel" class="shimmer-effect">{{
                activeShimmerMessage.latestShimmerLabel
              }}</span>
            </div>
          </div>
        </div>

        <!-- #3 PLAN_CHANGE_INFO_BAR as a new separate row -->
        <div class="change-mode-bar" *ngIf="isChangeMode">
          <div class="change-mode-header">
            <rt-back-arrow-icon
              class="cursor-pointer"
              tabindex="0"
              title="Back"
              (click)="cancelChangeMode()"
              (keydown.enter)="cancelChangeMode()"
            ></rt-back-arrow-icon>
            <span>{{ changeRequestTarget }}</span>
          </div>
        </div>

        <!-- #4 ANNOTATION_TOOLBAR -->
        <div class="selected-sids-container" *ngIf="(annotationToolService.selectedSids$ | async)?.length">
          <img src="assets/images/gif/rai-face-animated.gif" class="rai-chip-prefix" alt="Rai" />
          <div
            class="sid-chip"
            *ngFor="let item of annotationToolService.selectedSids$ | async"
            [pTooltip]="item.entity === 'DATA_MODEL' ? item.name + ' (' + item.dataModelName + ')' : item.name"
            tooltipPosition="top"
          >
            <ng-container *ngIf="item.entity === 'DATA_MODEL'; else defaultChip">
              {{ item.name }} ({{ item.dataModelName }})
            </ng-container>
            <ng-template #defaultChip>
              {{ item?.name || item?.sid || item }}
            </ng-template>
          </div>
        </div>

        <!-- #5 CHAT_BOX -->
        <div class="assistant-icon-wrapper">
          <img
            src="assets/images/gif/rai-face-animated.gif"
            class="assistant-icon chat-input-rai-icon"
            (click)="toggleChat()"
            (keydown.enter)="toggleChat()"
            (keydown.space)="toggleChat()"
            tabindex="0"
            *ngIf="isChatCollapsed"
            alt="Rai"
          />

          <div
            class="chat-input-wrapper"
            [class.has-input]="
              chatInput.trim() || attachedFile || (annotationToolService.selectedSids$ | async)?.length
            "
            [class.disabled]="
              appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || (isChatDisabled && !isChangeMode)
            "
            *ngIf="
              (activeSession?.isOwner &&
                (activeSession?.mergeStatus === SESSION_MERGE_STATUS.YET_TO_START ||
                  activeSession?.mergeStatus === SESSION_MERGE_STATUS.FAILED)) ||
              isNewSessionActive
            "
          >
            <!-- Attachment Pill -->
            <div class="attachment-pill" *ngIf="attachedFile">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
              <span class="file-name" [title]="attachedFile.name">{{ attachedFile.name }}</span>
              <button class="remove-btn" (click)="removeAttachment()" title="Remove file">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>

            <textarea
              [placeholder]="
                isChangeMode ? ('SPECIFY_CHANGES_TO_PROPOSAL' | translate) : ('WHAT_CAN_I_HELP_YOU_WITH' | translate)
              "
              [(ngModel)]="chatInput"
              (keydown.enter)="handleEnterKey($event)"
              (input)="autoGrowTextarea($event)"
              rows="1"
              #chatTextarea
              [disabled]="isChatDisabled && !isChangeMode"
            ></textarea>

            <div class="input-actions">
              <div class="input-actions-left">
                <!-- Hidden robust file input -->
                <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none" accept=".pdf" />

                <button
                  class="add-btn"
                  title="Upload"
                  (click)="fileInput.click()"
                  [disabled]="(isChatDisabled && !isChangeMode) || attachedFile"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                </button>
              </div>
              <div class="input-actions-right">
                <button
                  *ngIf="activeSession?.mode === SESSION_MODE.IDEATE || (isNewSessionActive && chatboxMode !== 'auto')"
                  class="mode-btn ideate-mode"
                  [class.active]="
                    chatboxMode === 'ideate' || (activeSession?.mode === SESSION_MODE.IDEATE && !isNewSessionActive)
                  "
                  [class.cancellable]="isNewSessionActive"
                  (click)="isNewSessionActive ? toggleChatboxMode('ideate') : null"
                  title="Ideate Mode"
                >
                  <rt-light-bulb-icon class="default-icon"></rt-light-bulb-icon>
                  <app-close-icon [width]="17" [height]="17" class="hover-icon"></app-close-icon>
                  <span
                    *ngIf="
                      chatboxMode === 'ideate' || (activeSession?.mode === SESSION_MODE.IDEATE && !isNewSessionActive)
                    "
                    class="mode-label"
                    >Ideate</span
                  >
                </button>
                <button
                  *ngIf="activeSession?.mode === SESSION_MODE.BUILD && !isNewSessionActive"
                  class="mode-btn build-mode active"
                  title="Build Mode"
                >
                  <rt-icon-rocket-02 width="14" height="14"></rt-icon-rocket-02>
                  <span class="mode-label">Build</span>
                </button>
                <button
                  *ngIf="activeSession?.mode === SESSION_MODE.BUILD || (isNewSessionActive && chatboxMode !== 'ideate')"
                  class="mode-btn auto-mode"
                  [class.active]="
                    (isNewSessionActive && chatboxMode === 'auto') ||
                    (activeSession?.mode === SESSION_MODE.BUILD && activeSession.driven === SESSION_DRIVEN_MODE.AUTO)
                  "
                  (click)="toggleChatboxMode('auto')"
                  title="Auto Mode"
                >
                  <rt-infinity-icon class="default-icon"></rt-infinity-icon>
                  <app-close-icon [width]="17" [height]="17" class="hover-icon"></app-close-icon>
                  <span *ngIf="chatboxMode === 'auto'" class="mode-label">Auto</span>
                </button>
                <button
                  class="send-btn"
                  (click)="onSendMessage()"
                  [class.has-input]="
                    chatInput.trim() || attachedFile || (annotationToolService.selectedSids$ | async)?.length
                  "
                  [disabled]="
                    (!chatInput.trim() && !attachedFile && !(annotationToolService.selectedSids$ | async)?.length) ||
                    (isChatDisabled && !isChangeMode)
                  "
                >
                  <app-arrow-up-icon [size]="16"></app-arrow-up-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </aside>

  <!-- Resize Handle -->
  <div
    class="resize-handle"
    (mousedown)="startResizing($event)"
    [class.handle-collapsed]="isChatCollapsed"
    *ngIf="!isAppManagementPage && isBetaAccessPrivilegeConsumable"
  >
    <div class="handle-bar"></div>
  </div>

  <!-- Preview Pane (RHS) -->
  <main class="preview-container" [class.collapsed-mode]="isContentCollapsed">
    <div class="preview-content">
      <!-- Modified: Wrapped content in Box Layout for standard look and feel -->
      <!-- Emulating behavior for any list/detail component loaded via router -->
      <app-box-layout [isContentCollapsed]="isContentCollapsed" [config]="boxLayoutConfig">
        <router-outlet></router-outlet>
      </app-box-layout>
    </div>
  </main>

  <p-dialog
    header="Application Details"
    [(visible)]="detailedDialogVisible"
    [modal]="true"
    [style]="{ width: '450px' }"
    [maximizable]="false"
    [draggable]="false"
    [resizable]="false"
    appendTo="body"
  >
    <app-application-details
      *ngIf="detailedDialogVisible"
      [appData]="selectedApp"
      (onCancel)="detailedDialogVisible = false"
      (onUpdate)="updateApplication($event)"
    ></app-application-details>
  </p-dialog>

  <app-search-overlay [isOpen]="isSearchOverlayOpen" (close)="isSearchOverlayOpen = false"></app-search-overlay>
</div>
